'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function wixIframeWrapper(WixElement) {
  var WixIframe =
  /*#__PURE__*/
  function (_WixElement) {
    _inheritsLoose(WixIframe, _WixElement);

    function WixIframe() {
      // eslint-disable-line no-useless-constructor
      return _WixElement.call(this) || this;
    }

    var _proto = WixIframe.prototype;

    _proto.connectedCallback = function connectedCallback() {
      var iframe = this.querySelector('iframe');
      this.observeChildAttributes(iframe, ['data-src']);

      _WixElement.prototype.connectedCallback.call(this);
    };

    _proto.reLayout = function reLayout() {
      //TODO - add load bi events, and preset TPAs reporting
      //TODO - add lazy loading if bv_lazyTPAs experiment is merged
      //TODO - handle instance templating from clientSpecMap once we implement static html loading
      var iframe = this.querySelector('iframe');

      if (iframe) {
        var dataSrc = iframe.dataset.src;

        if (dataSrc && dataSrc !== '' && iframe.src !== dataSrc) {
          iframe.src = dataSrc;
          iframe.dataset.src = '';
        }
      }
    };

    return WixIframe;
  }(WixElement);

  return WixIframe;
}

module.exports = wixIframeWrapper;
//# sourceMappingURL=wixIframe.js.map